import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datos-informar-internacion-request',
  templateUrl: './datos-informar-internacion-request.component.html',
  styleUrls: ['./datos-informar-internacion-request.component.scss']
})
export class DatosInformarInternacionRequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
